import { CSS2DObject } from "three/examples/jsm/renderers/CSS2DRenderer";
import "./Node.component.scss";

//TODO: Convert to using SVGs or HTML so that we can use CSS to style the text
export default function Node(node) {
	const classes = [
		"node",
		node.primary ? "node--primary" : "",
		"node--" + node.type,
		node.type === "focus" && !node.children.length ? "node--empty" : "",
	];

	const nodeEl = document.createElement("div");
	nodeEl.textContent = node.name;
	nodeEl.className = classes.join(" ");

	return new CSS2DObject(nodeEl);
}
